import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'

import {
  makeTranslationAware
} from '../../../utils'

const Button = styled.div`
  align-items: center;
  background-color: ${({ selected, theme }) => (
    selected ? theme.colors.main : theme.colors.grayContrast
  )};
  border-radius: 16px;
  color: ${({ selected, theme }) => (
    selected ? theme.colors.text.main : theme.colors.text.gray
  )};
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${({ selected, theme }) => {
      if (selected) {
        return theme.colors.main
      } else {
        return tinycolor(theme.colors.grayContrast).darken(10).toString()
      }
    }};
  }
`

const Content = styled.span`
  font-size: 1.15rem;
  margin-left: 4px;
  margin-right: 4px;
`

class RawSelectableButton extends React.PureComponent {
  static defaultProps = {
    onClick: null,
    selected: null
  }

  state = {
    selected: false
  }

  get selected() {
    if (this.props.selected !== null) {
      return this.props.selected
    }

    return this.state.selected
  }

  handleClick = () => {
    if (this.props.onClick === null) {
      this.setState({
        selected: !this.selected
      })
    } else {
      this.props.onClick()
    }
  }

  render() {
    return (
      <Button
        className={ this.props.className }
        onClick={ this.handleClick }
        selected={ this.selected }
      >
        { this.props.icon ? this.props.icon : null }
        <Content>
          { this.props.children }
        </Content>
      </Button>
    )
  }
}

const SelectableButton = makeTranslationAware(RawSelectableButton)

export { RawSelectableButton }
export default SelectableButton



// WEBPACK FOOTER //
// ./src/components/molecules/SelectableButton/SelectableButton.js